import { AnimatePresence, motion } from "framer-motion";

import cardLoading from "@assets/sales-v3-platform-loading-cell.gif";

import { type ModelMetadataKpiFormula } from "../../explore-budgets/client-setting/types";

import { ChannelComparisonActions } from "./channel-comparison-actions";
import { ChannelComparisonsModal } from "./channel-comparisons-modal";
import { type DataColumn } from "./incremental-spend-chart/const";
import { KpiBreakdown } from "./kpi-breakdown";

interface Props {
  isLoading: boolean;
  columns: DataColumn[];
  selectedKpi: ModelMetadataKpiFormula;
  costCurvesAllTimeData: any;
  costCurvesAllTimeByQuantileData: any;
  historicalContributionsData: any;
  weeklySpendsByChannel: Record<string, number[]>;
}

export const KpiBreakdowns = ({
  isLoading,
  columns,
  selectedKpi,
  costCurvesAllTimeData,
  costCurvesAllTimeByQuantileData,
  historicalContributionsData,
  weeklySpendsByChannel,
}: Props) => (
  <div>
    <ChannelComparisonActions />
    <div className="relative">
      <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(400px,1fr))] max-h-[750px] overflow-auto p-3 border border-v2-secondary rounded">
        {columns.map((column, index) => (
          <AnimatePresence key={column.column_name}>
            {isLoading ? (
              <motion.div
                className="border border-v2-secondary rounded-lg shadow-sm h-[230px] flex-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <img className="h-1/2" src={cardLoading} alt="Loading" />
              </motion.div>
            ) : (
              <KpiBreakdown
                column={column}
                index={index}
                historicalContributionsData={historicalContributionsData}
                selectedKpi={selectedKpi}
                costCurvesAllTimeData={costCurvesAllTimeData}
              />
            )}
          </AnimatePresence>
        ))}
      </div>
    </div>
    <ChannelComparisonsModal
      columns={columns}
      costCurvesAllTimeData={costCurvesAllTimeData}
      costCurvesAllTimeByQuantileData={costCurvesAllTimeByQuantileData}
      historicalContributionsData={historicalContributionsData}
      weeklySpendsByChannel={weeklySpendsByChannel}
    />
  </div>
);
